/**
 * The editing surface for the ProseMirror editor. App pages and commands
 * interact with the editor through the `editorEngine` service slot
 * (`EditorEngineContract`); this component renders the engine's own overlay
 * UI (slash menu, link menu, table menu, …).
 */
import { Editor } from '@bangle.io/editor';
import React from 'react';

export function EditorSurface(props: {
  wsPath: string;
  name: string;
  className?: string;
  readOnly?: boolean;
}) {
  return <Editor {...props} />;
}
